import {useBehavioralContext} from "../../contexts";
import {useState} from "preact/compat";

export const useSelfServiceAttendanceModal = () => {
    // Style to control whether the "close" button will be light or dark
    const [buttonStyle, setButtonStyle] = useState("dark");

    // Procedure to handle the "buttonStyle" state
    const handleButtonStyle = (style) => {
        setButtonStyle(style);
    }

    // Retrieves display data from the behavioral context
    const {
        isSelfServiceAttendanceModalOpen,
        selfServiceAttendanceModalData,
        handleSelfServiceAttendanceModal
    } = useBehavioralContext();

    // Bridge procedure to close the modal
    const handleClose = () => {
        handleSelfServiceAttendanceModal(false);
    }

    return {
        buttonStyle,
        isSelfServiceAttendanceModalOpen,
        selfServiceAttendanceModalData,
        handleButtonStyle,
        handleClose,
    }
}
